import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MedocSubscription } from 'src/app/core/models/cms/testimonial';

@Component({
  selector: 'app-subscription-card',
  templateUrl: './subscription-card.component.html',
  styleUrls: ['./subscription-card.component.scss']
})
export class SubscriptionCardComponent implements OnInit {
  @Input() pricingData: MedocSubscription | undefined;
  @Input() isMid: boolean = false 
  @Input() isEnglish = false;
  constructor(private router : Router, private translate: TranslateService) { }

  ngOnInit(): void {
  }

  openRegistration() {
    this.router.navigate([this.translate.currentLang, "get-started"]);
  }

}
